import React from 'react';
import { Wallet } from 'lucide-react';
import { format } from 'date-fns';

export const CashBalanceCard = ({ cashBalance }) => {
  if (!cashBalance) return null;
  return (
    <div className={`rounded-xl shadow-sm border-2 p-6 ${
      cashBalance.current_balance >= 0 ? 'bg-green-50 border-green-300' : 'bg-red-50 border-red-300'
    }`} data-testid="cash-balance-card">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Wallet className="w-6 h-6 text-gray-700" />
            <h2 className="text-lg font-bold text-gray-800">Your Cash Balance</h2>
          </div>
          <div className="grid grid-cols-3 gap-6 mt-4">
            <div>
              <p className="text-sm text-gray-600">Cash Received</p>
              <p className="text-xl font-bold text-blue-600">₹{cashBalance.total_advances.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Approved Expenses</p>
              <p className="text-xl font-bold text-orange-600">₹{cashBalance.total_approved_expenses.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Current Balance</p>
              <p className={`text-2xl font-bold ${
                cashBalance.current_balance >= 0 ? 'text-green-600' : 'text-red-600'
              }`}>
                {cashBalance.current_balance >= 0 ? '+' : ''}₹{cashBalance.current_balance.toFixed(2)}
              </p>
              {cashBalance.current_balance < 0 && (
                <p className="text-xs text-red-600 mt-1">⚠️ You have spent more than received</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {cashBalance.advances_history && cashBalance.advances_history.length > 0 && (
        <details className="mt-4">
          <summary className="cursor-pointer text-sm font-medium text-gray-700 hover:text-gray-900">
            View Cash Advance History ({cashBalance.advances_history.length} advances)
          </summary>
          <div className="mt-3 space-y-2">
            {cashBalance.advances_history.map((adv, idx) => (
              <div key={`${adv.date}-${adv.amount}-${idx}`} className="flex justify-between text-sm bg-white p-3 rounded-lg">
                <span className="text-gray-600">
                  {format(new Date(adv.date), 'MMM dd, yyyy')} - {adv.given_by}
                </span>
                <span className="font-semibold text-green-600">+₹{adv.amount.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
};
